import { ENDPOINTS } from 'src/constants/endpoints'

import type { IFundUpdateStatsResponseDTO } from 'src/app/home/pages/fund-updates/domain/contracts/fund-updates'
import { http } from 'src/interfaces/http'

export const getFundUpdatesStats =
  async (): Promise<IFundUpdateStatsResponseDTO> => {
    const { data } = await http.get<IFundUpdateStatsResponseDTO>(
      ENDPOINTS.hanwha.fundUpdatesStats,
    )
    return data
  }
